import { Button, Col, Form, Input, Modal, Row, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMasterDropdown,
  fetchMasterIblMonth,
  fetchMasterIblPeriod,
  fetchMasterTicketCategory,
  fetchMasterTicketSubCategory,
  resetIblMonth,
  resetTicketCategory,
  resetTicketSubCategory,
} from "../../../core/store/reducers/settings.slice";
import {
  checkTicketNudge,
  createNewTicket,
  getContactEmployeesByIds,
  getContactRoles,
} from "../../../core/store/reducers/tickets.slice";
import { RootState } from "../../../shared/constants";
import PopupMessageComponent from "../../../shared/layouts/message.layout";
import DocumentUpload from "./upload-doc.components";
import { formatDropDownValueNoUppercase } from "../../../shared/utilities";

function CreateTicket({
  formVisible = false,
  setFormVisible,
  reloadTickets,
}: any) {
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({ type: "self" } as any);
  const { contact_roles } = useSelector((state: RootState) => state.tickets);
  const [employeeList, setEmployeeList] = useState([] as any);
  const [nudgeData, setNudgeData] = useState({} as any);
  const [attachmentMandatory, setAttachmentMandatory] = useState(false as any);
  const [modalVisible, setModalVisible] = useState(false as any);
  const [resetFiles, setResetFiles] = useState(false as any);
  const [modalType, setModalType] = useState("" as any);
  const [modalButtons, setModalButtons] = useState((<></>) as any);
  const [modalTitle, setModalTitle] = useState("" as any);
  const [modalSubTitle, setModalSubTitle] = useState("" as any);

  const { incentive_portal_manager_view } = useSelector(
    (state: RootState) => state.auth
  );
  const [documents, setDocuments] = useState([] as any);
  const dispatch = useDispatch();
  const {
    master_ibl_month,
    master_ibl_period,
    master_ticket_category,
    master_ticket_sub_category,
    master_dropdown,
  } = useSelector((state: RootState) => state.settings);
  useEffect(() => {
    master_ibl_period?.length == 0 && dispatch(fetchMasterIblPeriod());
    // master_ibl_month?.length == 0 && dispatch(fetchMasterIblMonth());
    master_dropdown?.length == 0 && dispatch(fetchMasterDropdown());
    return () => {
      dispatch(resetIblMonth());
    };
  }, []);
  const resetFilesOnChange = () => {
    setResetFiles(true);
    setDocuments([]);
    setTimeout(() => {
      setResetFiles(false);
    }, 500);
  };
  const onValuesChange = (value: any, allValues: any) => {
    setFormValues(allValues);
    if (value.type) {
      form.resetFields();
      form.setFieldValue("type", value.type);
      resetFilesOnChange();
    }
    if (value.type == "team") {
      contact_roles?.length == 0 && dispatch(getContactRoles());
    }

    if (value?.role) {
      setEmployeeList([]);
      dispatch(getContactEmployeesByIds(value?.role)).then((val: any) => {
        if (val?.payload?.data?.data) {
          setEmployeeList(
            [...val?.payload?.data?.data].map((emp: any) => {
              return {
                name: emp.first_name + " " + emp.last_name,
                value: emp.id,
              };
            })
          );
        }
      });
    }
    if (value?.ibl_period_id) {
      form.setFieldValue("ibl_month", null);
      form.setFieldValue("ticket_category_id", null);
      form.setFieldValue("ticket_sub_category_id", null);
      form.setFieldValue("remarks", "");
      dispatch(resetIblMonth());
      dispatch(resetTicketCategory());
      dispatch(resetTicketSubCategory());
      dispatch(fetchMasterIblMonth({ ibl_period_id: value?.ibl_period_id }));
      dispatch(
        fetchMasterTicketCategory({ ibl_period_id: value?.ibl_period_id })
      );
      resetFilesOnChange();
    }
    if (value?.ibl_month) {
      form.setFieldValue("ticket_category_id", null);
      form.setFieldValue("ticket_sub_category_id", null);
      form.setFieldValue("remarks", "");
      resetFilesOnChange();
    }
    if (value?.ticket_category_id) {
      form.setFieldValue("ticket_sub_category_id", null);
      form.setFieldValue("remarks", "");
      dispatch(resetTicketSubCategory());
      dispatch(
        fetchMasterTicketSubCategory({
          ticket_category_id: value?.ticket_category_id,
        })
      );
      resetFilesOnChange();
    }
    if (value?.ticket_sub_category_id) {
      form.setFieldValue("remarks", "");
      resetFilesOnChange();
      setAttachmentMandatory(false);
      let payload = {
        ...allValues,
      };
      dispatch(checkTicketNudge(payload)).then((val: any) => {
        if (val?.payload?.data?.is_attachment_mandatory === true) {
          setAttachmentMandatory(true);
        }
      });
    }
  };
  const onFinish = (allValues: any) => {
    if (attachmentMandatory && documents?.length == 0) {
      message.warning("Uploading attachment is mandatory", 10);
      return;
    }
    setNudgeData({});
    let payload = {
      ...allValues,
      attachment_ids:
        documents?.length > 0
          ? documents?.map((val: any) => val.upload_id)
          : [],
    };
    if (payload?.contact_ids) {
      payload = { ...payload, employee_ids: payload?.contact_ids };
      delete payload?.contact_ids;
    }
    dispatch(checkTicketNudge(payload)).then((val: any) => {
      //   console.log(val);
      //   debugger;
      if (val?.payload?.data?.nudge_message) {
        setNudgeData(allValues);
        openWarningModal(
          val?.payload?.data?.nudge_message,
          "Do you still want to continue?"
        );
      } else {
        createTicket(allValues);
      }
    });
  };
  const closeModalPopup = () => {
    setModalVisible(false);
    setModalType("");
    setModalButtons(<></>);
    setModalSubTitle("");
    if (modalTitle == "Ticket Reported Successfully") {
      setFormVisible(false);
      reloadTickets();
    }
    setModalTitle("");
  };
  const openLoadingModal = (title: string) => {
    setModalTitle(title);
    setModalType("loading");
    setModalSubTitle("");
    setModalButtons(<></>);
    setModalVisible(true);
  };
  const openSuccessModal = (title: string, subTitle: string) => {
    setModalTitle(title);
    setModalType("success");
    setModalSubTitle(subTitle);
    setModalButtons(<></>);
    setModalVisible(true);
  };
  const openWarningModal = (title: string, subTitle: any) => {
    setModalTitle(title);
    setModalType("warning");
    setModalSubTitle(subTitle);
    setModalButtons(
      <>
        <Row gutter={32}>
          <Col span={12}>
            <Button size="large" block onClick={() => closeModalPopup()}>
              No
            </Button>
          </Col>
          <Col span={12}>
            <Button
              size="large"
              type="primary"
              block
              onClick={() => createTicket(formValues)}
            >
              Yes
            </Button>
          </Col>
        </Row>
      </>
    );
    setModalVisible(true);
  };
  const openErrorModal = (title: string, subTitle: any) => {
    setModalTitle(title);
    setModalType("error");
    setModalSubTitle(subTitle);
    setModalButtons(
      <>
        <Row gutter={32} justify="center">
          <Col span={8}>
            <Button size="large" block onClick={() => closeModalPopup()}>
              OK
            </Button>
          </Col>
        </Row>
      </>
    );
    setModalVisible(true);
  };
  //   createTicket(allValues);
  const createTicket = (allValues: any) => {
    openLoadingModal("Creating Ticket");
    setNudgeData({});
    const payload = {
      ...allValues,
      attachment_ids:
        documents?.length > 0
          ? documents?.map((val: any) => val.upload_id)
          : [],
    };
    dispatch(createNewTicket(payload)).then((val: any) => {
      console.log(val?.payload);
      if (val?.payload?.data?.data?.length > 0) {
        closeModalPopup();
        const allData = val?.payload?.data?.data;
        const duplicateTickets: any = [],
          createdTickets: any = [];
        allData?.map((val: any) => {
          let emp = employeeList?.filter(
            (contact: any) => val.contact_id == contact?.value
          );
          if (val.isDuplicate) {
            duplicateTickets.push({
              ...val,
              name: emp?.length > 0 ? emp[0].name : "",
            });
          } else {
            createdTickets.push({
              ...val,
              name: emp?.length > 0 ? emp[0].name : "",
            });
          }
        });
        const createdTicketIds = createdTickets?.map(
          (val: any) => val.display_id
        );
        if (duplicateTickets?.length > 0) {
          if (payload?.contact_ids?.length > 0) {
            const names = duplicateTickets?.map((val: any) => val.name);
            const names2 = createdTickets?.map((val: any) => val.name);
            let subText: any = <></>;
            let subText1 =
              createdTicketIds?.length > 0 ? (
                <>
                  Ticket created for {names2?.join(", ")} with Reference IDs #
                  {createdTicketIds.join(", #")} respectively.
                  <br />
                  <br />
                </>
              ) : (
                ""
              );
            let subText2 =
              duplicateTickets?.length == 1 && allData?.length == 1 ? (
                "Ticket already open for this request combination. Please contact support."
              ) : (
                <>
                  Ticket already open for this request combination against below
                  employee(s). Please contact support. <br />
                  {names?.map((val: any, idx: number) => (
                    <>
                      {idx + 1}. {val} <br />
                    </>
                  ))}
                </>
              );
            subText = (
              <>
                {subText1} {subText2}
              </>
            );
            openErrorModal("Error While Creating Tickets", subText);
          } else {
            openErrorModal(
              "Error While Creating Tickets",
              "Ticket already open for this request combination. Please contact support."
            );
          }
        } else {
          openSuccessModal(
            "Ticket Reported Successfully",
            "Reference id for Ticket : #" + createdTicketIds.join(", #")
          );
        }
      }
    });
  };
  return (
    <>
      <Modal
        title={<strong>Raise an Issue</strong>}
        centered
        visible={formVisible}
        onCancel={() => setFormVisible(false)}
        // width={1000}
        footer={false}
        className="modalFormButton form-modal"
        style={{ paddingBottom: "0px" }}
      >
        <Form
          form={form}
          name={"ticket_form"}
          className="app-form"
          onFinish={onFinish}
          //   onFinishFailed={onSaveLeadFailed}
          onValuesChange={onValuesChange}
          initialValues={{
            type: "self",
          }}
        >
          <div className="p-4">
            {incentive_portal_manager_view && (
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="type"
                    label="Issued For"
                    rules={[
                      {
                        required: true,
                        message: "Issued for is required",
                      },
                    ]}
                  >
                    <Select>
                      <Select.Option key="self" value="self">
                        Self
                      </Select.Option>
                      <Select.Option key="team" value="team">
                        Team
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {incentive_portal_manager_view && formValues?.type === "team" && (
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="role"
                    label="Select Role"
                    rules={[
                      {
                        required: true,
                        message: "Role is required",
                      },
                    ]}
                  >
                    <Select>
                      {contact_roles?.map((val: any) => {
                        return (
                          <Select.Option key={val.id} value={val.id}>
                            {val.role_name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {incentive_portal_manager_view && formValues?.type === "team" && (
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="contact_ids"
                    label="Select Employee"
                    rules={[
                      {
                        required: true,
                        message: "Employee is required",
                      },
                    ]}
                  >
                    <Select mode="multiple">
                      {employeeList?.map((val: any) => {
                        return (
                          <Select.Option key={val?.value} value={val?.value}>
                            {val?.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row>
              <Col span={24}>
                <Form.Item
                  name="ibl_period_id"
                  label="Select IBL Period"
                  rules={[
                    {
                      required: true,
                      message: "IBL Period is required",
                    },
                  ]}
                >
                  <Select>
                    {master_ibl_period?.map((val: any) => (
                      <Select.Option key={val.id} value={val.id}>
                        <span className="capitalize">{formatDropDownValueNoUppercase(val.name)}</span>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="ibl_month"
                  label="Select IBL Month"
                  rules={[
                    {
                      required: true,
                      message: "IBL Month is required",
                    },
                  ]}
                >
                  <Select>
                    {master_ibl_month?.map((val: any) => (
                      <Select.Option key={val} value={val}>
                        {val}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="ticket_category_id"
                  label="Select Ticket Category"
                  rules={[
                    {
                      required: true,
                      message: "Ticket Category is required",
                    },
                  ]}
                >
                  <Select>
                    {master_ticket_category?.map((val: any) => (
                      <Select.Option key={val.id} value={val.id}>
                        <span className="capitalize">{formatDropDownValueNoUppercase(val.name)}</span>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="ticket_sub_category_id"
                  label="Select Ticket Sub-Category"
                  rules={[
                    {
                      required: true,
                      message: "Ticket Sub-Category is required",
                    },
                  ]}
                >
                  <Select>
                    {master_ticket_sub_category?.map((val: any) => (
                      <Select.Option key={val.id} value={val.id}>
                        <span className="capitalize">{formatDropDownValueNoUppercase(val.name)}</span>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="remarks"
                  label="Select Remarks"
                  rules={[
                    {
                      required: true,
                      message: "Remarks is required",
                    },
                  ]}
                >
                  <Input.TextArea maxLength={1000} showCount={true} />
                </Form.Item>
              </Col>
            </Row>
            <DocumentUpload
              attachmentMandatory={attachmentMandatory}
              setDocuments={setDocuments}
              resetFiles={resetFiles}
            />
          </div>
          <Row
            className="modal-form-footer p-4"
            style={{
              backgroundColor: "#F3F4F7",
              borderTop: "1px solid #D9D9D9",
            }}
          >
            <Col span={24}>
              <Button type="primary" htmlType="submit" block size="large">
                Create Ticket
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      {modalVisible && (
        <PopupMessageComponent
          open={modalVisible}
          onCancel={closeModalPopup}
          title={modalTitle}
          subTitle={modalSubTitle}
          type={modalType}
          buttons={modalButtons}
        />
      )}
    </>
  );
}
export default CreateTicket;
